export default __webpack_public_path__ + "static/media/5.ef826319.png";